var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block-editor google-play-update-review-status" },
    [
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [_vm._v("Review ID")]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: "Google Play Review ID",
              "show-attributes": true,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.reviewId,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "reviewId", $$v)
              },
              expression: "clone.reviewId",
            },
          }),
          _vm._v(" "),
          _c("small", [_vm._v("Durumu güncellenecek yorumun ID'si")]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [_vm._v("Yeni Durum")]),
          _vm._v(" "),
          _c(
            "a-select",
            {
              staticClass: "classic-select",
              attrs: { placeholder: "Durum seçiniz" },
              model: {
                value: _vm.clone.status,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "status", $$v)
                },
                expression: "clone.status",
              },
            },
            [
              _c("a-select-option", { attrs: { value: "new" } }, [
                _vm._v("Yeni (new)"),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "replied" } }, [
                _vm._v("Yanıtlandı (replied)"),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "resolved" } }, [
                _vm._v("Çözüldü (resolved)"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v("Atanacak Temsilci (Opsiyonel)"),
          ]),
          _vm._v(" "),
          _c(
            "a-select",
            {
              staticClass: "classic-select",
              attrs: { placeholder: "Temsilci seçiniz", "allow-clear": "" },
              model: {
                value: _vm.clone.assigneeId,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "assigneeId", $$v)
                },
                expression: "clone.assigneeId",
              },
            },
            _vm._l(_vm.users, function (user) {
              return _c(
                "a-select-option",
                { key: user._id, attrs: { value: user._id } },
                [
                  _vm._v(
                    "\n                " + _vm._s(user.name) + "\n            "
                  ),
                ]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c("small", [_vm._v("Yorumu bir temsilciye atayabilirsiniz")]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }